// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "header[data-v-50d2029a]{z-index:10;position:relative;width:100vw;display:flex;height:60px;position:fixed;background:#fff}@media(min-width:900px){header[data-v-50d2029a]{position:absolute;background:transparent;height:119px}}header>div[data-v-50d2029a]{display:flex;width:100%;align-items:center;padding:0 20px}@media(min-width:900px){header>div[data-v-50d2029a]{padding:0 0 0 50px;justify-content:space-between}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
